import { capitalize } from 'lodash';
import React, { useCallback, useMemo, useState } from 'react';
import { Button, Divider, Text } from 'src/@vymo/ui/atoms';
import {
  Accordion,
  Body,
  Modal,
  Header as ModalHeader,
} from 'src/@vymo/ui/blocks';
import classnames from 'classnames';
import { getDetails } from 'src/models/details/selectors';
import { getRevyreConfig } from 'src/models/lmsConfig/selectors';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { callSelectedEntity } from '../thunk';
import {
  actionConfigMap,
  buildProfileActionOptions,
  getIsClickToCallEnabled,
  getQuickActionButtonHint,
  handleQuickActionItemClick,
} from './queries';
import styles from '../index.module.scss';

function ProfileActions(props) {
  const { actions, entityId, viewsCount } = props;
  const [showModal, setShowModal] = useState<string>('');
  const dispatch = useAppDispatch();
  const details = useAppSelector((state) => getDetails(state, entityId));
  const revyreConfig = useAppSelector(getRevyreConfig);

  const isClickToCallEnabled = useMemo(
    () => getIsClickToCallEnabled(props, details, revyreConfig),
    [details, props, revyreConfig],
  );

  const handleQuickAction = useCallback(
    (actionType, option) => {
      const { revyre } = props;
      if (revyre) {
        if (isClickToCallEnabled && actionType === 'call') {
          setShowModal('');
          dispatch(callSelectedEntity({ option, props, details }));
        } else {
          handleQuickActionItemClick(actionType, option);
        }
      }
    },
    [details, dispatch, isClickToCallEnabled, props],
  );
  return (
    <div
      className={classnames(styles.detailsWrapper__profileCard__quickActions, {
        [styles.detailsWrapper__profileCard__quickActions__marginTop]:
          viewsCount > 0,
      })}
    >
      {actions.map((action) => {
        const profileActions = buildProfileActionOptions(props, action);

        return (
          <>
            <Button
              variant="subtle"
              onClick={() => {
                setShowModal(action.type);
              }}
              iconProps={{
                icon: actionConfigMap[action.type]?.icon || null,
                iconPosition: 'left',
              }}
              className={
                styles.detailsWrapper__profileCard__quickActions__button
              }
            >
              {getQuickActionButtonHint(action.type)}
            </Button>
            {showModal === action.type && (
              <Modal
                open={Boolean(showModal.length)}
                showCloseButton
                onClose={() => setShowModal('')}
                classNames={
                  styles.detailsWrapper__profileCard__quickActions__modal
                }
              >
                <ModalHeader
                  className={
                    styles.detailsWrapper__profileCard__quickActions__modal__header
                  }
                >
                  <Text type="h4">{capitalize(action?.type)}</Text>
                </ModalHeader>
                <Body
                  className={
                    styles.detailsWrapper__profileCard__quickActions__modal__body
                  }
                >
                  {profileActions.map((profileOption) => (
                    <>
                      <Accordion
                        title={<Text type="h5">{profileOption.name}</Text>}
                        type="subtle"
                        description={profileOption.subLabel}
                        open
                      >
                        {profileOption?.options?.map((option) => (
                          // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
                          <div
                            className={
                              styles.detailsWrapper__profileCard__quickActions__modal__body__item
                            }
                            onClick={() =>
                              handleQuickAction(action?.type, option)
                            }
                          >
                            <div
                              className={
                                styles.detailsWrapper__profileCard__quickActions__modal__body__item__content
                              }
                            >
                              <Text type="subText" semiBold>
                                {option.name}
                              </Text>
                              <Text type="label">{option.subLabel}</Text>
                            </div>

                            <div
                              className={
                                styles.detailsWrapper__profileCard__quickActions__modal__body__item__icon
                              }
                            >
                              {option.icon}
                            </div>
                          </div>
                        ))}
                      </Accordion>
                      <Divider />
                    </>
                  ))}
                </Body>
              </Modal>
            )}
          </>
        );
      })}
    </div>
  );
}

export default ProfileActions;
